import { render } from "./ModelSection.vue?vue&type=template&id=aaabd646&scoped=true"
import script from "./ModelSection.vue?vue&type=script&lang=js"
export * from "./ModelSection.vue?vue&type=script&lang=js"

import "./ModelSection.vue?vue&type=style&index=0&id=aaabd646&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aaabd646"]])

export default __exports__